import { useQuery } from '@tanstack/react-query';
import FormControlledCalendar from '@/src/app/components/inputs/FormInputs/FormControlledCalendar';
import FormControlledMultipleDropdown from '@/src/app/components/inputs/FormInputs/FormControlledMultipleDropdown';
import { Company } from '@/src/app/Interfaces/admin/User.interfaces';
import { fetchUserCompanies } from '@/src/app/services/admin/UsersService';
import { getCompanyLabel } from '@/src/utils/formatUtils';
import FormControlledDropdown from '@/src/app/components/inputs/FormInputs/FormControlledDropdown';
import { Status } from '@/src/app/Interfaces/system/Generic.interfaces';
import { ClaimStatus } from '@/src/app/Interfaces/Insurance/Claim';

const ClaimsConsolidatedForm = () => {
  const getCompany = useQuery({
    queryKey: ['getUserCompaniesForm'],
    queryFn: async () => {
      return fetchUserCompanies();
    },
    refetchOnWindowFocus: false,
  });

  return (
    <div>
      <div className="grid mx-3 justify-content-center">
        <div className="col-12">
          <label htmlFor="companies" className="text-standard block mb-2">
            Companies
          </label>
          <FormControlledMultipleDropdown
            formID="companies"
            isLoading={getCompany.isLoading}
            isDisabled={getCompany.isError}
            options={getCompany.data?.map((company: Company) => ({
              ...company,
              label: getCompanyLabel(company),
            }))}
            labelField="label"
            valueField="id"
            placeholder={
              getCompany.isError
                ? 'Failed to load companies!'
                : 'Select company'
            }
            clearable={false}
            filter={true}
            resetFilterOnHide={true}
          />
        </div>
        <div className="col-12 lg:col-6">
          <label htmlFor="companies" className="text-standard block mb-2">
            Status
          </label>
          <FormControlledDropdown
            formID="status"
            defaultValue={ClaimStatus.Active}
            options={[
              { label: 'Active', value: ClaimStatus.Active },
              { label: 'Closed', value: ClaimStatus.Closed },
              { label: 'On Notice', value: ClaimStatus.OnNotice },
              { label: 'All', value: 'all' },
            ]}
            labelField="label"
            valueField="value"
            placeholder="Select state"
            clearable={false}
          />
        </div>
        <div className="col-12 lg:col-6" />
        <div className="col-12 lg:col-6">
          <label htmlFor="periodStart" className="text-standard block mb-2">
            Period Start
          </label>
          <FormControlledCalendar
            formID="periodStart"
            readOnlyInput
            showButtonBar
            className="w-full"
            triggerOnChange={true}
          />
        </div>
        <div className="col-12 lg:col-6">
          <label htmlFor="periodEnd" className="text-standard block mb-2">
            Period End
          </label>
          <FormControlledCalendar
            formID="periodEnd"
            readOnlyInput
            showButtonBar
            className="w-full"
            triggerOnChange={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ClaimsConsolidatedForm;
